<template>
  <div id="app">
    <template v-if="signedIn">
      <template v-if="isAdviser">
        <HeaderItem :signedIn="true" :isAdviser="true" />
      </template>
      <template v-else>
        <HeaderItem :signedIn="true" :isAdviser="false" />
      </template>
    </template>
    <template v-else>
      <template v-if="isAdviser">
        <HeaderItem :signedIn="false" :isAdviser="true" />
      </template>
      <template v-else>
        <HeaderItem :signedIn="false" :isAdviser="false" />
      </template>
    </template>
    <main class="common-main terms">
      <div class="item">
        <h2 class="common-title">利用規約</h2>
        <div class="item terms">
この利用規約（以下，「本規約」といいます。）は，株式会社ZINE（以下，「当社」といいます。）が本ウェブサイト上で提供するがん相談サービス「CancerWith」、「CancerWith for 住友生命」および「浜松オンラインがん相談 for 浜松医大」にご登録いただいたユーザーおよび有料のサービスをご契約いただいた，有料会員の資格を有するユーザーが利用する際の一切の行為に適用します。
<br><br>
<h3>第１条（定義）</h3>
<ol>
<li>「本サービス」とは，当社が運営する「CancerWith」、「CancerWith for 住友生命」および「浜松オンラインがん相談 for 浜松医大」と称するウェブサイト上で提供するサービスを指します。</li>
<li>「CancerWith有料プラン」とは，本サービス上で料金を支払うことにより，有料会員の資格を有するユーザーが利用することができるサービスを指します。</li>
<li>「有料会員の資格を有するユーザー」とは，CancerWith有料プランを利用するために契約をしているユーザーのことを指します。</li>
</ol>

<h3>第２条（目的）</h3>
<ol>
<li>本サービスは，がん患者およびその関係者への有益な情報の交換を目的としており，医師法１７条の「医業」（当該行為を行うに当たり，医師の医学的判断および技術をもってするのでなければ人体に危害を及ぼし，又は危害を及ぼすおそれのある行為を，反復継続する意思をもって行うこと）を行うものではありません。</li>
<li>本サービスにおいて回答期限は４８時間を目安としておりますが，同期限までに回答することを保証するものではありません。</li>
<li>本規約は，ユーザーおよび有料会員の資格を有するユーザーと当社との間の本サービスの利用に関わる一切の関係に適用されるものとします。</li>
<li>当社は本サービスに関し，本規約のほか，ご利用にあたってのルール等，各種の定め（以下，「個別規定」といいます。）をすることがあります。これら個別規定はその名称のいかんに関わらず，本規約の一部を構成するものとします。</li>
<li>本規約の規定が前条の個別規定の規定と矛盾する場合には，個別規定において特段の定めなき限り，個別規定の規定が優先されるものとします。</li>
</ol>

<h3>第３条（利用登録）</h3>
<ol>
<li>本サービスにおいては，登録希望者が本規約に同意の上，当社の定める方法によって利用登録を申請し，当社がこれを承認することによって，利用登録が完了するものとします。CancerWith有料プランについても，当社所定のオンラインフォーム上での申込みと本規約への同意を持って，当社と有料会員の資格を有するユーザーとの間で，契約が成立するものとします。</li>
<li>当社は，利用登録の申請者に以下の事由があると判断した場合，利用登録の申請を承認しないことがあり，その理由については一切の開示義務を負わないものとします。</li>
<ol>
<li>利用登録の申請に際して虚偽の事項を届け出た場合</li>
<li>本規約に違反したことがある者からの申請である場合</li>
<li>暴力団その他これに準じる反社会的勢力（以下「反社会的勢力等」といいます。）および反社会的勢力等と密接な関わりを有する者ならびにこれらに準じる者であると判明した場合</li>
<li>その他，当社が利用登録を相当でないと判断した場合</li>
</ol>
</ol>

<h3>第４条（ユーザーIDおよびパスワードの管理）</h3>
<ol>
<li>ユーザーおよび有料会員の資格を有するユーザーは，自己の責任において，本サービスのユーザーIDおよびパスワードを適切に管理するものとします。</li>
<li>ユーザーおよび有料会員の資格を有するユーザーは，いかなる場合にも，ユーザーIDおよびパスワードを第三者に譲渡又は貸与し，もしくは第三者と共用することはできません。当社は，ユーザーIDとパスワードの組み合わせが登録情報と一致してログインされた場合には，そのユーザーIDを登録しているユーザー自身による利用とみなします。</li>
<li>ユーザーIDおよびパスワードが第三者によって使用されたことによって生じた損害は，当社に故意又は重大な過失がある場合を除き，当社は一切の責任を負わないものとします。</li>
</ol>

<h3>第５条（料金支払）</h3>
<ol>
<li>有料会員の資格を有するユーザーは，CancerWith有料プランの対価として，当社が別途定め，本サービスに表示する利用料金を，当社が指定する方法により支払うものとします。</li>
<li>有料会員の資格を有するユーザーが前項の⽀払いを遅延した場合には，有料会員の資格を有するユーザーは遅延時から年１４．６％の割合による遅延損害金を支払うものとします。</li>
<li>当社は，有料会員の資格を有するユーザーがCancerWith有料プランの申込時には日本の消費税率を適用します。</li>
</ol>

<h3>第６条（禁止事項）</h3>
ユーザーおよび有料会員の資格を有するユーザーは，本サービスの利用にあたり，以下の行為をしてはなりません。

<ol>
<li>アドバイザーに対する相談の回答を強要する行為</li>
<li>本サービスが用意した相談の流れに沿わない行為</li>
<li>個人を特定しうる情報の投稿</li>
<li>低俗・わいせつな相談</li>
<li>虚偽情報の相談・投稿</li>
<li>医師法を含む法令に反する行為</li>
<li>「医業」（当該行為を行うに当たり，医師の医学的判断および技術をもってするのでなければ人体に危害を及ぼし，又は危害を及ぼすおそれのある行為を，反復継続する意思をもって行うこと）に該当する相談に回答を強要する行為</li>
<li>差別を意識させたり，それらにつながる行為</li>
<li>公序良俗に違反する行為</li>
<li>犯罪行為に関連する行為</li>
<li>本サービスの内容等，本サービスに含まれる著作権，商標権ほか知的財産権を侵害する行為</li>
<li>当社，他のユーザー，アドバイザー，又はその他第三者のサーバー又はネットワークの機能を破壊したり，妨害したりする行為</li>
<li>本サービスによって得られた情報を商業的に利用する行為</li>
<li>当社の許可なく商品・サービスを取引する行為</li>
<li>当社のサービスの運営を妨害するおそれのある行為</li>
<li>不正アクセスをし，又はこれを試みる行為</li>
<li>他のユーザーおよびアドバイザーに関する個人情報等を収集又は蓄積する行為</li>
<li>不正な目的を持って本サービスを利用する行為</li>
<li>本サービスの他のユーザー，アドバイザー，又はその他の第三者に不利益，損害，不快感を与える行為</li>
<li>アカウントの不正利用行為（なりすまし，他人のアカウントの利用，ひとりで複数のアカウントを所持，アカウントの譲渡・売買）</li>
<li>当社が許諾しない本サービス上での宣伝，広告，勧誘，選挙活動又は営業行為</li>
<li>本サービス外で，他のユーザー又はアドバイザーに直接接触する行為</li>
<li>本サービス外で，他のユーザー又はアドバイザーに関する情報，相談や返信内容，画像を転載・転用する行為</li>
<li>当社のサービスに関連して，反社会的勢力に対して直接又は間接に利益を供与する行為</li>
<li>その他，当社が不適切と判断する行為</li>
</ol>

<h3>第７条（本サービスの提供の停止等）</h3>
<ol>
<li>当社は，事前の通知や承諾なしに本サービスの一時的な運営の停止を行うことがあり，ユーザーおよび有料会員の資格を有するユーザーはこれを予め承諾するものとします。また，本サービスの一時的な運営の停止により生じたいかなる損害についても，当社はユーザーおよび有料会員の資格を有するユーザーに対して一切責任を負いません。</li>
<ol>
<li>本サービスのサーバの保守，データベースの瑕疵の修補等を行う場合</li>
<li>本サービスの仕様変更に伴う移行作業を行う場合</li>
<li>天災地変その他非常事態が発生し，もしくは発生するおそれがあり，又は法令等の改正・成立により本サービスの運営が困難又は不可能になった場合</li>
<li>その他，当社がやむを得ない事由により本サービスの運営上一時的な停止が必要と判断した場合</li>
</ol>
<li>当社は，アクセス過多，その他予期せぬ要因で表示速度の低下や障害等に起因し，ユーザーおよび有料会員の資格を有するユーザーに対して損害が生じた場合，前項と同様，当社はユーザーおよび有料会員の資格を有するユーザーに対して一切責任を負いません。</li>
</ol>

<h3>第８条（CancerWith有料プランの契約期間）</h3>
<ol>
<li>本契約の有効期間は，本契約成立日（同日を含みます。）から，CancerWith有料プランの利用申込時に当社所定の方法で決定された期間が経過する日までとします。</li>
<li>有効期間満了日の前日までに，有料会員の資格を有するユーザーがCancerWith有料プランからの退会又は変更の手続を行わない場合は，前項の有効期間と同一の期間にて，当該有料プランが自動的に更新されます。</li>
</ol>

<h3>第９条（利用制限および登録抹消）</h3>
<ol>
<li>当社は，ユーザーおよび有料会員の資格を有するユーザーが以下のいずれかに該当する場合には，事前の通知なく，ユーザーに対しては，本サービスの全部もしくは一部の利用を制限し，有料会員の資格を有するユーザーに対しては，CancerWith有料プランの全部もしくは一部の利用を制限し，又はユーザーおよび有料会員の資格を有するユーザーとしての登録を抹消することができるものとします。</li>
<ol>
<li>本規約のいずれかの条項に違反した場合</li>
<li>登録事項に虚偽の事実があることが判明した場合</li>
<li>本サービス上で定められた利用料金の支払債務の不履行があった場合</li>
<li>当社からの連絡に対し，一定期間返答がない場合</li>
<li>本サービスについて，最終の利用から一定期間利用がない場合</li>
<li>反社会的勢力等および反社会的勢力等と密接な関わりを有する者ならびにこれらに準じる者であることが発覚した場合</li>
<li>その他、当社が本サービスの利用又はCancerWith有料プランの利用を適当でないと判断した場合</li>
</ol>
<li>当社は，本条に基づき当社が行った行為によりユーザーおよび有料会員の資格を有するユーザーに生じた損害について，一切の責任を負いません。</li>
</ol>

<h3>第１０条（CancerWith有料プランの終了・変更）</h3>
<ol>
<li>当社は，本サービス運営上の都合により，いつでもCancerWith有料プランの全部又は一部を，終了又は変更できるものとします。</li>
<li>当社は，CancerWith有料プランの終了又は変更を行う場合，その影響および運営状況などに照らし，適切な時期および適切な方法により情報提供を行うものとします。</li>
<li>当社は，CancerWith有料プランの終了又は変更により，有料会員の資格を有するユーザー又は第三者が被ったいかなる不利益又は損害についても，一切の責任を負わないものとします。</li>
</ol>

<h3>第１１条（退会）</h3>
ユーザーおよび有料会員の資格を有するユーザーは，当社の定める退会手続により，本サービスから退会できるものとします。
<br><br>

<h3>第１２条（権利義務の譲渡禁止）</h3>
ユーザーおよび有料会員の資格を有するユーザーは，当社の書面又は電磁的記録による事前の承諾なく，本規約に基づく契約上の地位又は本規約に基づく権利もしくは義務を第三者に譲渡し，又は担保に供することはできません。
<br><br>

<h3>第１３条（保証の否認および免責事項）</h3>
<ol>
<li>当社は，本サービスに事実上又は法律上の瑕疵（安全性，信頼性，正確性，完全性，有効性，特定の目的への適合性，セキュリティ等に関する欠陥，エラーやバグ，権利侵害等を含みます。）がないことを明示的にも黙示的にも保証しておりません。</li>
<li>本サービスを通じて交換される情報については，ユーザーおよび有料会員の資格を有するユーザーの責任により内容の当否を判断していただくものとし，当社は本サービスに起因してユーザーおよび有料会員の資格を有するユーザーに生じたあらゆる損害について一切の責任を負いません。ただし，本サービスに関する当社とユーザーおよび有料会員の資格を有するユーザーとの間の契約（本規約を含みます。）が消費者契約法に定める消費者契約となる場合，この免責規定は適用されません。</li>
<li>前項ただし書に定める場合であっても，当社は，当社の過失（重過失を除きます。）による債務不履行又は不法行為によりユーザーおよび有料会員の資格を有するユーザーに生じた損害のうち特別な事情から生じた損害（当社又はユーザーが損害発生につき予見し，又は予見し得た場合を含みます。）について一切の責任を負いません。また，当社の過失（重過失を除きます。）による債務不履行又は不法行為によりユーザーに生じた損害の賠償は，ユーザーから当該損害が発生した月に受領した利用料の額を上限とします。</li>
<li>当社は，本サービスに関して，有料会員の資格を有するユーザーを含むユーザーと、有料会員の資格を有するユーザーを含む他のユーザー又は第三者との間において生じた取引，連絡又は紛争等について一切責任を負いません。</li>
<li>本サービスは，海外在住の日本人の利用も可能ですが，居住国の法規制により何らかの損害を被った場合は，当社は一切責任を負いません。</li>
</ol>

<h3>第１４条（サービス内容の変更等）</h3>
当社は，ユーザーおよび有料会員の資格を有するユーザーに通知することなく，本サービスの内容を変更し又は本サービスの提供を中止することができるものとし，これによってユーザーおよび有料会員の資格を有するユーザーに生じた損害について一切の責任を負いません。
<br><br>

<h3>第１５条（規約の変更）</h3>
<ol>
<li>当社は，ユーザーおよび有料会員の資格を有するユーザーに事前に通知（本サービス上に提示した場合を含みます。）することで，本規約等を変更することができます。</li>
<li>ユーザーおよび有料会員の資格を有するユーザーが本規約等の変更に同意しない場合は，前項の通知後，１か月以内に書面又は電磁的記録にて当社に対して通知しなければなりません。</li>
<li>当社が本条第２項に定める本規約等の変更を承諾しない旨の通知を受領した場合を除き，ユーザーおよび有料会員の資格を有するユーザーが本サービスの利用を継続した場合，ユーザーおよび有料会員の資格を有するユーザーは通知日にさかのぼって変更後の本規約等を承認したものとみなし，当社が設定しユーザーおよび有料会員の資格を有するユーザーに対して通知した当該変更条件適用開始日をもって当該変更が効力を有するものとします。</li>
</ol>

<h3>第１６条（個人情報の取扱い）</h3>
当社は，本サービスの利用によって取得する個人情報については，当社「プライバシーポリシー」に従い適切に取り扱うものとします。
<br><br>

<h3>第１７条（通知又は連絡）</h3>
ユーザーおよび有料会員の資格を有するユーザーと当社との間の通知又は連絡は，当社の定める方法によって行うものとします。当社は，ユーザーおよび有料会員の資格を有するユーザーから，当社が別途定める方式に従った変更届け出がない限り，現在登録されている連絡先が有効なものとみなして当該連絡先へ通知又は連絡を行い，これらは，発信時にユーザーおよび有料会員の資格を有するユーザーへ到達したものとみなします。
<br><br>

<h3>第１８条（権利義務の譲渡の禁止）</h3>
ユーザーおよび有料会員の資格を有するユーザーは，当社の書面による事前の承諾なく，利用契約上の地位又は本規約に基づく権利もしくは義務を第三者に譲渡し，又は担保に供することはできません。
<br><br>

<h3>第１９条（準拠法）</h3>
本規約の成⽴，効⼒，履⾏および解釈に関しては，⽇本法が適⽤されるものとします。
<br><br>

<h3>第２０条（合意管轄）</h3>
本規約に関して，裁判上の争いが⽣じたときは，東京地方裁判所を専属的合意管轄とします。
<br><br>

<h3>第２１条（お問い合わせ窓口）</h3>
本規約に関するお問い合わせは，下記の窓口までお願いいたします。
<br><br>
株式会社ZINE CancerWith運営事務局<br>
<a :href="contactUrl" target="_blank">お問い合わせフォーム</a>
<br><br>
<br><br>
2020年12月17日 制定<br>
2021年2月4日 改定<br>
2021年12月28日 改定<br>
2022年9月8日 改定<br>
2022年10月1日 改定<br>
2023年5月1日 改定
        </div>
      </div>
    </main>
    <FooterItem :hiddenFooterFixedButton="true" />
  </div>
</template>

<script>
import { Analytics/*, Logger*/ } from "aws-amplify"
import HeaderItem from './Header'
import FooterItem from './Footer'
import { Common } from './Common.js'

//const logger = new Logger('Terms');
//window.LOG_LEVEL = 'VERBOSE'
//logger.info('info bar');
//logger.debug('debug bar');
//logger.warn('warn bar');
//logger.error('error bar');
Analytics.autoTrack('pageView', {
  enable: true,
  eventName: 'pageView',
  type: 'multiPageApp',
  provider: 'AWSPinpoint',
  getUrl: () => {
    return window.location.origin + window.location.pathname;
  }
});

export default {
  name: 'terms',
  components: {
    HeaderItem,
    FooterItem
  },
  mixins:[Common],
  data() {
    return {
      contactUrl: '',
    }
  },

  mounted() {
    let env = this.getEnv(location.hostname)
    this.contactUrl = 'https://share.hsforms.com/1X-5z7FfYQlSKleMOQ57vzA46sq5?cancerwith_env=' + env
  },
  
  async beforeCreate() {  
    Analytics.record({
      name: 'accessLog', 
      attributes: { 
        page: 'Terms',
        url: window.location.origin + window.location.pathname
      }
    });

    // GA
    if (location.hostname === 'cancerwith.com') {
      this.$gtag.pageview({
        page_path: '/terms',
        page_title: '利用規約 (/terms)'
      })
    }
  }
}
</script>
